module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_8023.e0f4978d.png";